<template>
  <div id="content" v-html="html"></div>
</template>

<script>
import AgreementHmtl from './agreement';

export default {
  name: 'Agreement',
  data() {
    return {
      html: AgreementHmtl,
    };
  },
};
</script>

<style scoped>
#content {
  width: 100%;
  box-sizing: border-box;
  padding: 15px;
}
#content >>> p {
  text-align: left !important;
}

#content >>> li,
#content >>> ul {
  text-align: left !important;
}
</style>
